import PATHS from '@/router/paths'

const PERSON_INTERNAL_USERS = () => {
  const parameters = {
    'access.role': () => [{ operator: 'eq', value: 'internal' }],
  }

  return {
    didFail: false,
    groupKey: 'managerPersonId',
    groupName: 'manager',
    id: 'INTERNAL_USERS',
    isLoading: true,
    items: [],
    parameters,
    styles: {
      background: 'primary',
      text: 'white',
      value: 'white',
    },
    subtitle: 'Users',
    title: 'Internal',
  }
}

const PERSON_EXTERNAL_USERS = () => {
  const parameters = {
    'access.role': () => [{ operator: 'neq', value: 'internal' }],
  }

  return {
    didFail: false,
    groupKey: 'billingCodes',
    groupName: 'org',
    id: 'EXTERNAL_USERS',
    isLoading: true,
    items: [],
    parameters,
    styles: {
      background: 'primary',
      text: 'white',
      value: 'white',
    },
    subtitle: 'Users',
    title: 'External',
  }
}

const PERSON_CONFIG_ERRORS = () => {
  const parameters = {
    isConfigValid() {
      return [{ operator: 'is', value: false }]
    },
  }

  return {
    didFail: false,
    groupKey: 'access.role',
    groupName: 'role',
    id: 'CONFIG_ERROR',
    isLoading: true,
    items: [],
    parameters,
    styles: {
      background: 'primary',
      text: 'white',
      value: 'white',
    },
    subtitle: 'Records',
    title: 'Requires Review',
  }
}

const summaries = {
  organization: {
    ACTIVE: {
      didFail: false,
      format: 'boolean',
      id: 'ACTIVE',
      isLoading: true,
      styles: {
        background: 'primary',
        text: 'white',
        value: 'white',
      },
      subtitle: 'Organizations',
      title: 'Active',
      total: 0,
      parameters: {
        isActive() {
          return [{ operator: 'incl', value: true }]
        },
        isDeleted() {
          return [{ operator: 'incl', value: false }]
        },
      },
    },
  },
  [PATHS.INTERNAL.TIME_ROLLUP]: {
    BILLABLE: {
      didFail: false,
      format: 'hhmm',
      id: 'BILLABLE',
      isLoading: true,
      items: [],
      mtd: false,
      styles: {
        background: 'primary',
        text: 'white',
        value: 'white',
      },
      subtitle: 'Hours',
      title: 'Billable',
      total: 0,
    },
    'NON-BILLABLE': {
      didFail: false,
      format: 'hhmm',
      id: 'NON-BILLABLE',
      isLoading: true,
      items: [],
      mtd: false,
      styles: {
        background: 'primary',
        text: 'white',
        value: 'white',
      },
      subtitle: 'Hours',
      title: 'Non-Billable',
      total: 0,
    },
    PROJECT: {
      didFail: false,
      format: 'hhmm',
      id: 'PROJECT',
      isLoading: true,
      items: [],
      mtd: false,
      styles: {
        background: 'primary',
        text: 'white',
        value: 'white',
      },
      subtitle: 'Hours',
      title: 'Project',
      total: 0,
    },
    ADX: {
      didFail: false,
      format: 'hhmm',
      id: 'ADX',
      isLoading: true,
      items: [],
      mtd: false,
      styles: {
        background: 'primary',
        text: 'white',
        value: 'white',
      },
      subtitle: 'Hours',
      title: 'AdX',
      total: 0,
    },
    'ADX-PG': {
      didFail: false,
      format: 'hhmm',
      id: 'ADX-PG',
      isLoading: true,
      items: [],
      mtd: false,
      styles: {
        background: 'primary',
        text: 'white',
        value: 'white',
      },
      subtitle: 'Hours',
      title: 'AdX-PG',
      total: 0,
    },
    TOTAL: {
      didFail: false,
      format: 'hhmm',
      id: 'TOTAL',
      isLoading: true,
      items: [],
      mtd: false,
      styles: {
        background: 'white',
        text: 'darkestblue',
        value: 'darkestblue',
      },
      subtitle: 'Hours',
      title: 'Total',
      total: 0,
    },
  },
  project: {
    ACTIVE: {
      didFail: false,
      format: 'boolean',
      id: 'ACTIVE',
      isLoading: true,
      styles: {
        background: 'primary',
        text: 'white',
        value: 'white',
      },
      subtitle: 'Projects',
      title: 'Active',
      total: 0,
      parameters: {
        isActive() {
          return [{ operator: 'incl', value: true }]
        },
        isDeleted() {
          return [{ operator: 'incl', value: false }]
        },
      },
    },
  },
  [PATHS.INTERNAL.TIME_SHEET]: {
    BILLABLE: {
      didFail: false,
      format: 'hhmm',
      id: 'BILLABLE',
      isLoading: true,
      items: [],
      mtd: true,
      styles: {
        background: 'primary',
        text: 'white',
        value: 'white',
      },
      subtitle: 'MTD',
      title: 'Billable',
      total: 0,
    },
    'NON-BILLABLE': {
      didFail: false,
      format: 'hhmm',
      id: 'NON-BILLABLE',
      isLoading: true,
      items: [],
      mtd: true,
      styles: {
        background: 'primary',
        text: 'white',
        value: 'white',
      },
      subtitle: 'MTD',
      title: 'Non-Billable',
      total: 0,
    },
    PROJECT: {
      didFail: false,
      format: 'hhmm',
      id: 'PROJECT',
      isLoading: true,
      items: [],
      mtd: true,
      styles: {
        background: 'primary',
        text: 'white',
        value: 'white',
      },
      subtitle: 'MTD',
      title: 'Project',
      total: 0,
    },
    ADX: {
      didFail: false,
      format: 'hhmm',
      id: 'ADX',
      isLoading: true,
      items: [],
      mtd: false,
      styles: {
        background: 'primary',
        text: 'white',
        value: 'white',
      },
      subtitle: 'Hours',
      title: 'AdX',
      total: 0,
    },
    'ADX-PG': {
      didFail: false,
      format: 'hhmm',
      id: 'ADX-PG',
      isLoading: true,
      items: [],
      mtd: false,
      styles: {
        background: 'primary',
        text: 'white',
        value: 'white',
      },
      subtitle: 'Hours',
      title: 'AdX-PG',
      total: 0,
    },
    TOTAL: {
      didFail: false,
      format: 'hhmm',
      id: 'TOTAL',
      isLoading: true,
      items: [],
      mtd: true,
      styles: {
        background: 'white',
        text: 'darkestblue',
        value: 'darkestblue',
      },
      subtitle: 'MTD',
      title: 'Total',
      total: 0,
    },
  },

  person: {
    INTERNAL_USERS: PERSON_INTERNAL_USERS(),
    EXTERNAL_USERS: PERSON_EXTERNAL_USERS(),
    CONFIG_ERROR: PERSON_CONFIG_ERRORS(),
  },
}

export default summaries
